import { useEffect, useState } from "react";
import { useAccount } from "wagmi";

import { isLedgerConnectorId, isLedgerLiveBrowser } from "@config/ledger";

const useLedgerLive = () => {
  const { connector } = useAccount();

  const [isLedgerInjected, setIsLedgerInjected] = useState(false);

  useEffect(() => {
    setIsLedgerInjected(isLedgerLiveBrowser());
  }, []);

  // Ledger reaches the app either as the EIP-6963 connector or as the
  // auto-connect one, so both ids mean the session is running through Ledger.
  const isLedgerConnected = isLedgerConnectorId(connector?.id);

  const isLedgerLiveENV = isLedgerInjected && isLedgerConnected;

  return { isLedgerConnected, isLedgerInjected, isLedgerLiveENV };
};

export default useLedgerLive;
